import { IDeviceOutputDto } from './device-output-dto.interface';
import { TachographDriverStatus } from '../enums';

interface ICoordinates {
    type: string;
    coordinates: [number, number];
}

export interface ITachographDataOutputDto {
    id: number;
    device?: IDeviceOutputDto | number;
    coordinates?: ICoordinates;
    heading?: number;
    timestamp: string;
    insertedAt?: string;
    speed?: number;
    cardId?: string;
    driverStatus: TachographDriverStatus;
    cardStatus?: boolean;
    dailyDrivingTime?: number;
    weeklyDrivingTime?: number;
    remainingDailyDrivingTime?: number;
    remainingWeeklyDrivingTime?: number;
    biweeklyDrivingTime?: number;
    currentDailyDrivingTime?: number;
    currentWeeklyDrivingTime?: number;
    remainingCurrentDrivingTime?: number;
    remainingShiftDrivingTime?: number;
    cumulativeBreakTime?: number;
    timeLeftUntilDailyRest?: number;
    timeLeftUntilWeeklyRest?: number;
    nextBreakDuration?: number;
    timeUntilNextBreak?: number;
    dailyDrivingTimeExceeds?: number;
    driverCardIdMsb?: string;
    driverCardIdLsb?: string;
    cardIssuingMemberState?: string;
}
